import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark, faInfoCircle, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useToast } from '../../hooks/useToast';

const ICONS = {
  success: faCheck,
  error: faXmark,
  info: faInfoCircle,
  warning: faTriangleExclamation,
};

const COLORS = {
  success: 'var(--color-success)',
  error: 'var(--color-error)',
  info: 'var(--color-info)',
  warning: 'var(--color-warning)',
};

export function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: 'var(--space-6)',
        right: 'var(--space-6)',
        zIndex: 'var(--z-modal)' as unknown as number,
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-3)',
        maxWidth: '380px',
      }}
    >
      {toasts.map(toast => (
        <div
          key={toast.id}
          role="alert"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-3)',
            padding: 'var(--space-3) var(--space-4)',
            background: 'var(--color-surface-glass)',
            backdropFilter: 'blur(var(--glass-blur))',
            border: `1px solid ${COLORS[toast.type]}40`,
            borderRadius: 'var(--radius-lg)',
            boxShadow: 'var(--shadow-lg)',
            animation: 'slideUp 0.3s var(--ease-out-expo)',
            fontSize: 'var(--text-sm)',
            color: 'var(--color-text-primary)',
          }}
        >
          <FontAwesomeIcon icon={ICONS[toast.type]} style={{ color: COLORS[toast.type], flexShrink: 0 }} />
          <span style={{ flex: 1 }}>{toast.message}</span>
          <button
            onClick={() => removeToast(toast.id)}
            aria-label="Dismiss"
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--color-text-tertiary)',
              cursor: 'pointer',
              padding: 'var(--space-1)',
              flexShrink: 0,
            }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      ))}
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
